const messages = {
  en: {
    login: {
      welcomeMessage: "Welcome!",
      enterCredentials: "Enter your email and password to log in",
      password: "Password",
      rememberMe: "Remember me",
      signIn: "Sign In",
      wrongPassword: "Wrong password!",
      unverified: "Email not verified!",
      wrongCredentials: "Incorrect login details!",
    },
    teachers: {
      teachers: "Trainers",
      teachersTable: "Trainers Table",
      createTeacher: "Create new trainer",
      createNewTeacher: "Creating new trainer",
      teacher: "Trainer",
      address: "Address",
      mobile: "Mobile",
      activ: "Active",
      employedSince: "Employed since",
      employedSinceDate: "Employment start date",
      details: "Details",
      teacherCreated: "Trainer successfully created!",
      teacherUpdated: "Trainer successfully updated!",
      teacherDeleted: "Trainer successfully deleted!",
      activated: "Trainer successfully activated!",
      search: "Search trainers...",
      detail: {
        teacherDetails: "Trainer details",
        teacherName: "Trainer name",
        courseTitle: "Place name",
        subcourseTitle: "Group name",
        numberOfCandidate: "Number of students",
        subcourseStartDate: "Group start date",
        currentSubcourseProgress: "Current group progress",
        subcourseDuration: "Group duration",
        months: "months",
        month: "month",
        teachSubcourses: "This trainer teaches the following groups: ",
      },
      edit: {
        editingTeacher: "Editing trainer",
      },
      pastMonths: "Current installment",
      teacherPermanentlyDelete:
        "This action will permanently delete the Teacher!",
    },
    global: {
      appTitle: "Financial Assistant",
      selectLanguage: "Select language",
      edit: "Edit",
      delete: "Delete",
      deleted: "Deleted",
      yes: "Yes",
      no: "No",
      close: "Close",
      createdAt: "Created at",
      logout: "Logout",
      currency: "RSD",
      create: "Create",
      error: "Error",
      requiredField: "Required field",
      areYouSure: "Are you sure?",
      deletingCancelled: "Deletion cancelled!",
      actionCancelled: "Action cancelled!",
      typePass: "Enter password!",
      submit: "Submit",
      cancel: "Cancel",
      seasons: "Seasons",
      newSeason: "New season",
      creatingCancelled: "Creation cancelled!",
      loading: "Loading...",
      plsWait: "Please wait while your request is being processed...",
      roleUnauthenticated: "You do not have permission for this action!",
      activate: "Activate",
      uploadImage: "Upload Image",
      deleteForever: "Delete Forever",
      activationCancelled: "Activation Cancelled",
    },
    navigation: {
      search: "Search...",
    },
    courses: {
      createCourse: "Create place",
      createNewCourse: "Creating place",
      selectCourse: "Select place",
      courses: "Places",
      coursesSubcourses: "Places/Group",
      title: "Place name",
      createdSuccessfully: "Place Successfully Created!",
      updatedSuccessfully: "Place Successfully Updated!",
      editingCourse: "Editing place",
      successDelete: "Place successfully deleted!",
      activated: "Place successfully activated!",
      coursePermanentlyDelete: "This action will permanently delete the Place!",
      detail: {
        courseDetails: "Place details",
        selectCourse: "Select Course",
        courseName: "Place name",
        subcourseTitle: "Group name",
        coursePrice: "Group price",
      },
    },
    subcourses: {
      subcourses: "Groups",
      createSubcourse: "Create group",
      createNewSubcourse: "Creating group",
      selectSubcourse: "Select group",
      subcourseTitle: "Group name",
      subcourseDetails: "Group details",
      coursePrice: "Group price",
      numberOfMonths: "Group duration (number of months)",
      startFrom: "Group start",
      discount: "Discount",
      addSubcourse: "Add group",
      subcourseCreated: "Group Successfully Created!",
      subcourseUpdated: "Group Successfully Updated!",
      editingSubcourse: "Editing group",
      subcourseDeleted: "Group successfully deleted!",
      checkKids: "The following students are attending this group: ",
      activated: "Gruoup successfully activated!",
      subcoursePermanentlyDelete:
        "This action will permanently delete the Group!",
      successDelete: "Group Successfully Deleted!",
      courseDeleted:
        "Activation is not possible. The Place this Group belongs to has been deleted!",
    },
    parents: {
      parents: "Parents",
      parent: "Parent",
      name: "Parent name",
      createParent: "Create parent",
      createNewParent: "Creating parent",
      parentCreated: "Parent successfully created!",
      notes: "Notes",
      unpaidInstallments: "Number of unpaid installments",
      sendigReminders: "Sending reminders",
      kidsCount: "Number of children",
      selectParent: "Select parent",
      editingParent: "Editing parent",
      parentEdited: "Parent successfully updated!",
      checkKids: "Parent oversees the following students:",
      parentPermanentlyDelete:
        "This action will permanently delete the Parent!",
      parentDeleted: "Parent successfully deleted!",
      search: "Search parents...",
    },
    kids: {
      kids: "Students",
      kid: "Student",
      kid_s: "Students",
      name: "Student name",
      subscribedSubcourse: "Attending group",
      numberOfPayments: "Number of installments",
      sendigReminders: "Reminders sending",
      createKid: "Create student",
      createNewKid: "Creating student",
      unpaidInstallments: "Overview of debts",
      birthday: "Date of birth",
      kidUpdating: "Editing student",
      kidUpdated: "Student successfully updated!",
      kidDeleted: "Student successfully deleted!",
      numberByMonths: "Number of students per month",
      numberBySubcourses: "Number of students per groups",
      deletedKids: "Graduated students",
      search: "Search students...",
      kidStatistic: "Statistics of enrolled students by month",
      kidPermanentlyDelete:
        "This action will permanently delete the Candidate!",
      parentDeleted: "Activation is not possible. The parent has been deleted!",
      activated: "Candidate successfully activated!",
    },
    payments: {
      amount: "Payment amount",
      paymentDate: "Payment date",
      sendReminders: "Send reminders",
      remindersSent: "Reminders successfully sent!",
      sendRemindersWarning: "This action will send reminders to parents!",
      currUnpiadAm: "Current debt",
      partiallyPayment: "Partial payment",
      shortViewPayment: "Brief overview of payments and debts",
      unpaidInstallments: "Unpaid installments",
      fullDebt: "Total expected gross income",
      notAllowedReverse: "Records of payments made cannot be reversed!",
    },
    seasons: {
      createSeason: "Create new season",
      seasonCreated: "Season successfully created!",
      seasonAlreadyCreated: "Season already exists!",
      dbAlreadyExists: "Database already exists!",
      titles: "Seasons",
      title: "Season",
    },
    Dashboard: "Dashboard",
    Teachers: "Trainers",
    Pages: "Pages",
    Courses: "Places",
    Subcourses: "Groups",
    Parents: "Parents",
    Kids: "Students",
    Kid: "Student",
    Deleted: "Deleted items",
    Billing: "Payments",
    Profile: "Profile",
    SignIn: "Log In",
    SignOut: "Log Out",
    Payments: "Payments",
    Debits: "Debts",
    LoginForm: "Log In",
    Login: "Login",
    Logout: "Logout",
    Seasons: "Seasons",
  },
  sr: {
    login: {
      welcomeMessage: "Dobrodošli!",
      enterCredentials: "Unesite email i lozinku kako biste se prijavili",
      password: "Lozinka",
      rememberMe: "Zapamti me",
      signIn: "Prijava",
      wrongPassword: "Pogrešna lozinka!",
      unverified: "Email nije verifikovan!",
      wrongCredentials: "Netačni podaci za prijavu!",
    },
    teachers: {
      teachers: "Treneri",
      teachersTable: "Tabela trenera",
      createTeacher: "Kreiraj novog trenera",
      createNewTeacher: "Kreiranje novog trenera",
      teacher: "Trener",
      address: "Adresa",
      mobile: "Mobilni tel.",
      activ: "Aktivan",
      employedSince: "Zaposlen od",
      employedSinceDate: "Datum početka rada",
      details: "Detalji",
      teacherCreated: "Trener uspešno kreiran!",
      teacherUpdated: "Trener uspešno ažuriran!",
      teacherDeleted: "Trener uspešno obrisan!",
      activated: "Trener uspešno aktiviran!",
      search: "Pretraži trenere...",
      detail: {
        teacherDetails: "Detalji trenera",
        teacherName: "Ime trenera",
        courseTitle: "Naziv mesta",
        subcourseTitle: "Naziv grupe",
        numberOfCandidate: "Broj polaznika",
        subcourseStartDate: "Početak grupe",
        currentSubcourseProgress: "Trenutni napredak grupe",
        subcourseDuration: "Trajanje grupe",
        months: "meseci",
        month: "mesec",
        teachSubcourses: "Ovaj trener podučava sledeće grupe: ",
      },
      edit: {
        editingTeacher: "Uređivanje trenera",
      },
      pastMonths: "Aktuelna rata",
      teacherPermanentlyDelete: "Ova akcija će trajno izbrisati nastavnika!",
    },
    global: {
      appTitle: "Finansijski Asistent",
      selectLanguage: "Izaberi jezik",
      edit: "Uredi",
      delete: "Obriši",
      deleted: "Obrisano",
      yes: "Da",
      no: "Ne",
      close: "Zatvori",
      createdAt: "Datum kreiranja",
      logout: "Odjava",
      currency: "RSD",
      create: "Kreiraj",
      error: "Greška",
      requiredField: "Obavezno polje",
      areYouSure: "Da li ste sigurni?",
      deletingCancelled: "Brisanje otkazano!",
      actionCancelled: "Akcija otkazana!",
      typePass: "Unesite lozinku!",
      submit: "Pošalji",
      cancel: "Otkaži",
      seasons: "Sezone",
      newSeason: "Nova sezona",
      creatingCancelled: "Kreiranje otkazano!",
      loading: "Učitavanje...",
      plsWait: "Molimo sačekajte dok se vaš zahtev obrađuje...",
      roleUnauthenticated: "Nemate ovlašćenja za ovu akciju!",
      activate: "Aktiviraj",
      uploadImage: "Otprema slike",
      deleteForever: "Izbriši zauvek",
      activationCancelled: "Aktiviranje otkazano!",
    },
    navigation: {
      search: "Pretraži...",
    },
    courses: {
      createCourse: "Kreiraj mesto",
      createNewCourse: "Kreiranje mesta",
      selectCourse: "Izaberi mesto",
      courses: "Mesta",
      coursesSubcourses: "Mesta/Grupa",
      title: "Naziv mesta",
      createdSuccessfully: "Mesto uspešno kreirano!",
      updatedSuccessfully: "Mesto uspešno ažurirano!",
      editingCourse: "Uređivanje mesta",
      successDelete: "Mesto uspešno obrisano!",
      activated: "Mesto uspešno aktivirano!",
      coursePermanentlyDelete: "Ova akcija će trajno izbrisati mesto!",
      detail: {
        courseDetails: "Detalji mesta",
        courseName: "Naziv mesta",
        subcourseTitle: "Naziv grupe",
        coursePrice: "Cena grupe",
      },
    },
    subcourses: {
      subcourses: "Grupe",
      createSubcourse: "Kreiraj grupu",
      createNewSubcourse: "Kreiranje grupe",
      selectSubcourse: "Izaberi grupu",
      subcourseTitle: "Naziv grupe",
      subcourseDetails: "Detalji grupe",
      coursePrice: "Cena grupe",
      numberOfMonths: "Trajanje grupe (broj meseci)",
      startFrom: "Početak grupe",
      discount: "Popust",
      addSubcourse: "Dodaj grupu",
      subcourseCreated: "Grupa uspešno kreirana!",
      subcourseUpdated: "Grupa uspešno ažurirana!",
      editingSubcourse: "Uređivanje grupe",
      subcourseDeleted: "Grupa uspešno obrisana!",
      checkKids: "Sledeći polaznici pohađaju ovu grupu: ",
      activated: "Grupa uspešno aktivirana!",
      subcoursePermanentlyDelete: "Ova akcija će trajno obrisati grupu!",
      successDelete: "Grupa uspešno obrisana!",
      courseDeleted:
        "Aktivacija nije moguća. Mesto kome pripada ova grupa je obrisana!",
    },
    parents: {
      parents: "Roditelji",
      parent: "Roditelj",
      name: "Ime roditelja",
      createParent: "Kreiraj roditelja",
      createNewParent: "Kreiranje roditelja",
      parentCreated: "Roditelj uspešno kreiran!",
      notes: "Beleške",
      unpaidInstallments: "Broj neplaćenih rata",
      sendigReminders: "Slanje podsetnika",
      kidsCount: "Broj dece",
      selectParent: "Izaberi roditelja",
      editingParent: "Uređivanje roditelja",
      parentEdited: "Roditelj uspešno ažuriran!",
      checkKids: "Roditelj nadzire sledeće polaznike:",
      parentPermanentlyDelete: "Ova akcija će trajno obrisati roditelja!",
      parentDeleted: "Roditelj uspešno obrisan!",
      search: "Pretraži roditelje...",
    },
    kids: {
      kids: "Polaznici",
      kid: "Polaznik",
      kid_s: "Polaznici",
      name: "Ime polaznika",
      subscribedSubcourse: "Pohađa grupu",
      numberOfPayments: "Broj rata",
      createKid: "Kreiraj polaznika",
      createNewKid: "Kreiranje polaznika",
      unpaidInstallments: "Pregled dugovanja",
      kidsCount: "Broj polaznika",
      birthday: "Datum rođenja",
      kidUpdating: "Uređivanje polaznika",
      kidUpdated: "Polaznik uspešno ažuriran!",
      kidDeleted: "Polaznik uspešno obrisan!",
      numberByMonths: "Broj polaznika po mesecima",
      numberBySubcourses: "Broj polaznika po grupama",
      deletedKids: "Svršeni polaznici",
      search: "Pretraži polaznike...",
      kidStatistic: "Statistika upisanih polaznika po mesecima",
      kidPermanentlyDelete: "Ova akcija će trajno obrisati polaznika!",
      parentDeleted: "Aktivacija nije moguća. Roditelj je obrisan!",
      activated: "Polaznik uspešno aktiviran!",
    },
    payments: {
      amount: "Iznos uplate",
      paymentDate: "Datum uplate",
      sendReminders: "Pošalji podsetnike",
      remindersSent: "Podsetnici uspešno poslati!",
      sendRemindersWarning: "Ova radnja će poslati potsetnike roditeljima!",
      currUnpiadAm: "Trenutni nenaplaćeni iznos ",
      partiallyPayment: "Procenat uplate",
      shortViewPayment: "Skraćeni prikaz duga/uplata polaznika",
      unpaidInstallments: "Duguje rata",
      fullDebt: "Ukupan očekivani bruto prihod",
      notAllowedReverse: "Evidencije izvršenih uplata se ne mogu stornirati!",
    },
    seasons: {
      createSeason: "Kreiraj novu sezonu",
      seasonCreated: "Sezona uspešno kreirana!",
      seasonAlreadyCreated: "Sezona već postoji!",
      dbAlreadyExists: "Baza podataka već postoji!",
      titles: "Sezone",
      title: "Sezona",
    },
    Dashboard: "Naslovna",
    Teachers: "Treneri",
    Pages: "Stranice",
    Courses: "Mesta",
    Subcourses: "Grupe",
    Parents: "Roditelji",
    Kids: "Polaznici",
    Kid: "Polaznik",
    Deleted: "Obrisane stavke",
    Billing: "Plaćanja",
    Profile: "Profil",
    SignIn: "Prijavi se",
    SignOut: "Odjavi se",
    Payments: "Uplate",
    Debits: "Dugovanja",
    LoginForm: "Prijava",
    Login: "Prijava",
    Logout: "Odjava",
    Seasons: "Sezone",
  },
};
export default messages;
